<template>
  <div class="wg-row">
    <div :class="['wg-col','wg-xs-12',contactId === null ? 'wg-sm-12 wg-md-12' : 'wg-sm-3 wg-md-3']" v-show="contactId === null || windowWidth > 767">
      <wg-modal
        :width="windowWidth > 700 ? '300px' : '80%'"
        v-if="sortingModalStatus"
        @closeModal="closeSortingModal()"
      >
        <div class="wg-row" slot="header" style="flex-wrap:nowrap;align-items:center;">
          <div
            class="com-anm22-app-text-xl"
            slot="header"
          >{{ $anm22.strLang(lang, 'Order', 'Ordinamento') }}</div>
        </div>
          <div slot="body">
          <div class="wg-row">
            <div class="com-anm22-app-text-xl">{{ $anm22.strLang(lang, 'Contacts status', 'Stati contatto') }}</div>
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div
            class="wg-row cont"
            style="align-items:center;flex-wrap:nowrap;margin-bottom:10px;position:relative;"
            v-for="(f,index) in orderingStatusFields"
            @click="orderingStatusField = f.field;changeOrderingField()"
            :key="'field-'+index"
          >
            <div :style="{fontSize:'15px',marginLeft:'8px'}">{{f.label}}</div>
            <div class="cont-tick" v-if="orderingStatusField == f.field">
              <img style="width:20px;" :src="$anm22.icons.getWorldIcon('tick')" />
            </div>
          </div>

          <div class="wg-row">
            <div class="com-anm22-app-text-xl">{{ $anm22.strLang(lang, 'Contacts', 'Contatti') }}</div>
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div
            class="wg-row cont"
            style="align-items:center;flex-wrap:nowrap;margin-bottom:10px;position:relative;"
            v-for="(f,index) in orderingContactsFields"
            @click="orderingContactsField = f.field;changeOrderingContactsField()"
            :key="'field-contact'+index"
          >
            <div :style="{fontSize:'15px',marginLeft:'8px'}">{{f.label}}</div>
            <div class="cont-tick" v-if="orderingContactsField == f.field">
              <img style="width:20px;" :src="$anm22.icons.getWorldIcon('tick')" />
            </div>
          </div>
        </div>
      </wg-modal>
      <div class="status-list-header">
        <img class="work-img" :src="$anm22.getObjIcon($store.getters['works/get'](workSelected), 'workDefault')">
        <div class="name">{{$store.getters["works/get"](workSelected).name}}</div>
        <img @click="$emit('openModalViews')" class="change-view" :src="$anm22.icons.getWorldIcon('viewCols')" />
        <img @click="openSortingModal()" class="sort-modal" :src="$anm22.icons.getWorldIcon('sort')" />
        <a :href="selectWorkUrl"><img class="change-work" :src="$anm22.icons.getWorldIcon('menuSwitch')" /></a>
      </div>
      <div
        v-if="filters.length > 0"
        class="wg-row"
        style="
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          height:30px;
        "
      >
        <div
          v-for="(filter, index) in filters"
          :key="'filter-' + index"
          class="display-flex filter-button"
          @click="$emit('remove-filter',index)"
        >
          <img
            class="com-anm22-app-img-fixed-height-s"
            :src="$anm22.icons.getWorldIcon('deleteBlack')"
            style="margin-right: 10px"
          />
          <div class="com-anm22-app-text-m">{{ filter.name }}</div>
        </div>
      </div>
      <div ref="kanbanCanvas" class="status-list-container com-anm22-app-scrolling-panel" @scroll="updateViewHorizontalPos">
        <div
          v-for="(status, statusId) in orderedContactsStatusList"
          :id="'contacts-status-div-' + status.idContactsContactStatus"
          :key="'status-' + statusId"
          :class="['status-box',filters.length > 0 ? 'filters' : '' ,'com-anm22-app-scrolling-panel']"
          @drop="statusDrop(status.idContactsContactStatus)"
          @dragover="statusDragOver"
          @scroll="getNextContacts(status.idContactsContactStatus)"
        ><div class="status-name"><span class="name-label" :style="{borderLeft:status.color != '' ? '3px solid' + ' ' + status.color : ''}" >{{status.name}}</span><span class="counter">({{contactsByStatus(status.idContactsContactStatus).length}})</span></div>
          <!-- Lista contatti -->
          <router-link
            :to="'/contact/' + (contact.idContactsContact)"
            v-for="(contact, index) in contactsByStatusOrderedByLastFeed(status.idContactsContactStatus).slice(0,contactsListsLimit[status.idContactsContactStatus])"
            :ref="'contact-' + contact.idContactsContact"
            :key="'full-contact-' + index"
            @dragstart="statusDragStart(contact.idContactsContact)"
            @mouseover="updateViewVerticalPos(status.idContactsContactStatus, this.scrollTop)"
            draggable="true"
          >
            <div
              :class="[
                'wg-row',
                'item ',
                'selectable',
                reminderClass(contact),
                contactId == contact.idContactsContact ? 'selected' : '',
                contact.lastOpen < contact.lastFeedUpdate ? 'to-read' : '',
              ]"
            >
              <div class="container">
                <img
                  :src="
                    contact.type == 2
                      ? $anm22.getObjIcon(contact, 'workMaterial')
                      : $anm22.getContactIcon(contact, $store)
                  "
                  class="image"
                />
              </div>
              <div class="wg-row" style="align-items:center;">
                <div class="wg-row name">
                  {{ $anm22.getContactName(contact, $store) }}<span v-if="$anm22.getReferrerFlag(contact, $store) == 0">{{ $anm22.getContactReferrerName(contact, $store) }}</span>
                  <img
                    v-if="!isSynchronized(contact.idContactsContact)"
                    class="com-anm22-app-img-fixed-height-s"
                    :src="$anm22.icons.getWorldIcon('offline')"
                    style="margin-left: 5px"
                    :title="
                      $anm22.strLang(lang, 'Not synchronized', 'Non sincronizzato')
                    "
                  />
                </div>
                <div v-if="contact.lastFeedDate"
                  class="contact-last-feed"
                  :title="
                    $anm22.strLang(lang, 'Last feed', 'Ultimo feed')"
                >
                  {{ contact.lastFeedDate | moment('DD-MM-YYYY HH:mm') }}
                </div>
                <div
                  v-if="contact.pauseDate && (contact.pauseDate > Math.floor(Date.now() / 1000))"
                  class="contact-pause"
                  :title="
                    $anm22.strLang(lang, 'Pause', 'Contatto in pausa')"
                >
                  {{ contact.pauseDate | moment('DD-MM-YYYY') }}
                </div>
                <div v-if="contact.value && contact.value != 0"
                  class="contact-value"
                  :title="
                    $anm22.strLang(lang, 'Lead value', 'Valore lead')"
                >
                  {{ contact.value }}
                </div>
                <template v-if="contact.referenceAgent">
                  <div style="min-width:21px;width:21px;height:21px;margin-right:2px;">
                    <world-object-icon :customTitle="getCustomTitle($store.getters['users/get'](contact.referenceAgent))" :type="'user'" :obj="$store.getters['users/get'](contact.referenceAgent)" :isImg="true"></world-object-icon>
                  </div>
                </template>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <!-- Legenda -->
      <div class="com-anm22-app-scrolling-panel legend">
        <div
          v-for="(color, index) in legendColors"
          :key="'lg-' + index"
          :style="
            'border-left:4px solid ' +
            color.color +
            ';padding:2px 10px 2px 5px;font-size:12px;'
          "
        >
          {{ color.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";
import WorldContactForm from "../../../../../world/spa/components/WorldContactForm.vue";
import Contact from "../Contact.vue";

export default {
  props: {
    contacts: Array,
    filters: Array,
    view: String,
    reminderClass: Function,
    sortingModalStatus: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      dragContact: null,
      orderingStatusField: this.$anm22.getCookie("contacts_status_cols_ordering") !== ""
          ? this.$anm22.getCookie("contacts_status_cols_ordering")
          : "ascStatus",
      orderingContactsField:this.$anm22.getCookie("contacts_cols_ordering") !== ""
          ? this.$anm22.getCookie("contacts_cols_ordering")
          : "lastFeedDate",
      contactsListLimit: 20,
      contactsListsLimit: {},
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      windowWidth: (state) => state.windowWidth,
      workSelected: (state) => state.workSelected
    }),
    legendColors() {
      let colors = [];
      colors.push(
        {
          name: this.$anm22.strLang(this.lang, "Not read", "Non letto"),
          color: "grey",
        },
        {
          name: this.$anm22.strLang(this.lang, "Day before to 10 minutes before appointment", "Dal giorno precedente a 10 minuti prima dell'appuntamento"),
          color: "#007fff",
        },
        {
          name: this.$anm22.strLang(this.lang, "10 minutes before appointment to end day", "Da 10 minuti prima dell'appuntamento a fine giornata"),
          color: "#F6BE00",
        },
        {
          name: this.$anm22.strLang(this.lang, "Day after appointment", "Dal giorno seguente l'appuntamento"),
          color: "#f00",
        }
      );
      return colors;
    },
    sortingStatus() {
      return (a, b) => {
        if (this.orderingStatusField == "ascStatus") {
          if (a.level > b.level) {
            return 1;
          } else if (a.level < b.level) {
            return -1;
          } else {
            return 0;
          }
        }
        if (this.orderingStatusField == "descStatus") {
          if (a.level < b.level) {
            return 1;
          } else if (a.level > b.level) {
            return -1;
          } else {
            return 0;
          }
        }
      };
    },
    sortingContacts() {
      return (a, b) => {
        if (this.orderingContactsField == "lastFeedDate") {
          if (a.lastFeedDate < b.lastFeedDate) {
            return 1;
          } else if (a.lastFeedDate > b.lastFeedDate) {
            return -1;
          } else {
            return 0;
          }
        }
        if (this.orderingContactsField == "ascValue") {
          if (a.value > b.value) {
            return 1;
          } else if (a.value < b.value) {
            return -1;
          } else {
            return 0;
          }
        }
        if (this.orderingContactsField == "descValue") {
          if (a.value < b.value) {
            return 1;
          } else if (a.value > b.value) {
            return -1;
          } else {
            return 0;
          }
        }
        if (this.orderingContactsField == "colorPriority") {
          if (a.priority < b.priority) {
            return 1;
          } else if (a.priority > b.priority) {
            return -1;
          } else {
            return 0;
          }
        }
      };
    },
    orderingStatusFields() {
      return [
        {
          field: "ascStatus",
          label: this.$anm22.strLang(this.lang, 'Level - Increasing', 'Livello - Crescente'),
        },
        {
          field: "descStatus",
          label: this.$anm22.strLang(this.lang, 'Level - Decreasing', 'Livello - Descrescente'),
        },
      ];
    },
    orderingContactsFields() {
      return [
        {
          field: "lastFeedDate",
          label: this.$anm22.strLang(this.lang, 'Last interaction', 'Ultima interazione'),
        },
        {
          field: "ascValue",
          label: this.$anm22.strLang(this.lang, 'Lead value - Increasing', 'Valore lead - Crescente'),
        },
        {
          field: "descValue",
          label: this.$anm22.strLang(this.lang, 'Lead value - Decreasing', 'Valore lead - Decrescente'),
        },
        {
          field: "colorPriority",
          label: this.$anm22.strLang(this.lang, 'Last reminder', 'Ultimo reminder'),
        }
      ];
    },
    //Stati in base al work selezionato
    contactsStatus() {
      return this.$store.getters["contactsStatus/getByWork"](this.workSelected);
    },
    contactId() {
      return this.$store.getters["getContactSelected"];
    },
    orderedContactsStatusList() {
      var status = this.contactsStatus;
      //status.unshift({"id":null,"name":"Nessuno stato","level":0});
      // status.sort(function(a, b) {
      //   if (a.level < b.level) {
      //     return -1;
      //   } else if (a.level > b.level) {
      //     return 1;
      //   } else {
      //     return 0;
      //   }
      // });
      return status.sort(this.sortingStatus);
    },
  },
  methods: {
    resetContact() {
      this.$store.dispatch("selectContact", null);
      document.title = "ANM22 Contacts";
    },
    selectContact(contactId) {
      if (this.$store.getters["contacts/get"](contactId)) {
        if (contactId === this.contactId) {
          this.resetContact();
        } else {
          this.$store.dispatch("selectContact", contactId);
        }
      }
    },
    contactsByStatus(statusId, work) {
      return this.contacts.filter(c => c.status == statusId);
    },
    contactsByStatusOrderedByLastFeed(statusId, work) {
      var contacts = this.contacts.filter(c => c.status == statusId);
      return contacts.sort(this.sortingContacts);
    },
    isSynchronized(id) {
      return this.$store.getters["offline/isSynchronized"](
        this.$anm22.MD5("ContactsContact" + id)
      );
    },
    statusDragStart(contactId) {
      console.log("Drag start");
      this.dragContact = this.$store.getters["contacts/get"](contactId);
    },
    statusDrop(statusId) {
      console.log("Drop");
      this.changeStatus(this.dragContact,statusId);
      this.dragContact = null;
    },
    statusDragOver(ev) {
      console.log("Drag over");
      ev.preventDefault();
    },
    statusChangedText(contact,statusId) {
      let text = "";
      //VECCHIO STATO
      let fromStatus = this.$store.getters['contactsStatus/get'](contact.status);
      //STATO SELEZIONATO
      let toStatus = this.$store.getters['contactsStatus/get'](statusId);
      if(!fromStatus && toStatus) {
        text = this.$anm22.strLang(this.lang, 'Contact added to' + ' ' + toStatus.name , 'Contatto aggiunto in'  + ' ' + toStatus.name)
      } else if(fromStatus && !toStatus) {
        text = this.$anm22.strLang(this.lang, 'Contact status removed ','Stato del contatto rimosso')
      } else if(fromStatus && toStatus) {
        text = this.$anm22.strLang(this.lang, 'Contact status changed to' + ' ' + toStatus.name, 'Lo stato del contatto è cambiato in' + ' ' + toStatus.name)
      }
      return text;
    },
    async changeStatus(contact,statusId) {
      let msgData = {
        text: this.statusChangedText(contact,statusId),
        description: "",
        type: "changeStatus",
        contentType: "plain",
        fromStatus: contact.status,
        toStatus: statusId
      }
      contact.status = statusId;
      try {
        const response = await this.$http.post("contact/change-status", {
          contactId: contact.idContactsContact,
          newStatus: contact.status,
          msgData:msgData
        }, {
          withCredentials: true
        });
        this.$store.dispatch("contacts/update", {
          vlf: this.$vlf("contacts"),
          objs: [response.data.contact]
        });
        this.$store.dispatch("messages/update", {
          vlf: this.$vlf("messages"),
          objs: [response.data.messages]
        });
        /* Messaggio creazione progetti */
        let engText = "";
        let itText = "";
        if(response.data.projects && response.data.projects.length > 0) {
          engText = " - Successfully created projects";
          itText = " - Progetti creati correttamente";
        }
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Contact status changed successfully" + engText,
            "Stato del contatto cambiato con successo" + itText
          ),
          type: "suggestion",
        });
      } catch (e) {
        console.log(e);
      } finally {
        this.$anm22.eventBus.$emit('wg-modal-close');
      }
    },
    getCustomTitle(user) {
      if (!user) return '';
      return this.$anm22.strLang(this.lang, 'Accountable -' + ' ' + user.name + ' ' + user.surname, 'Responsabile -' + ' ' + user.name + ' ' + user.surname);
    },
    changeOrderingField() {
      this.$anm22.setCookie("contacts_status_cols_ordering", this.orderingStatusField, 31536000);
    },
    changeOrderingContactsField() {
      this.$anm22.setCookie("contacts_cols_ordering", this.orderingContactsField, 31536000);
    },
    getNextContacts(statusId) {
      const itemsNum = 20;
      let bottomOfList = document.getElementById('contacts-status-div-' + statusId).scrollTop + document.getElementById('contacts-status-div-' + statusId).clientHeight >= this.contactsListsLimit[statusId] * 61;
      if (bottomOfList) {
        this.contactsListsLimit[statusId] += itemsNum;
        console.log("Loading next contacts...");
        this.$forceUpdate();
      }
    },
    checkListLimitAfterResize() {
      window.addEventListener('resize', (event) => {
        if (window.innerHeight / 61 >= this.contactsListLimit) {
          this.contactsListLimit = Math.round(window.innerHeight / 61);
          console.log("Resized kanbann to " + this.contactsListLimit + " items");
        } 
        this.contactsStatus.forEach((status)=>{
          if (this.contactsListsLimit[status.idContactsContactStatus] < this.contactsListLimit) {
            this.contactsListsLimit[status.idContactsContactStatus] = this.contactsListLimit;
          }
        });
      }, true);
    },
    updateViewHorizontalPos(e) {
      this.$anm22.setCookie("co_cs_k_px", Math.round(e.srcElement.scrollLeft), 86400);
    },
    updateViewVerticalPos(col, posY) {
      console.log(posY);
      this.$anm22.setCookie("co_cs_k_col", col, 86400);
      this.$anm22.setCookie("co_cs_k_py", Math.round(posY), 86400);
    },
    openSortingModal() {
      this.$emit('changeSortingModalStatus', true);
    },
    closeSortingModal() {
      this.$emit('changeSortingModalStatus', false);
    },
    closeNewContactModal() {
      this.$emit('changeNewContactModalStatus', false);
    },
    selectWorkUrl() {
      return (process.env.NODE_ENV === 'production' ? 'https://www.anm22.it' : process.env.VUE_APP_FRONT_DOMAIN) + '/app/work/selectWork?nullOption=1&cbSucc=..%2Fcontacts-v%2F';
    },
  },
  components: {
    "vue-simple-spinner": Spinner,
    WorldContactForm,
    Contact,
  },
  created() {
    if (window.innerHeight / 61 >= this.contactsListLimit) {
      this.contactsListLimit = Math.round(window.innerHeight / 61);
      console.log("Resized kanbann to " + this.contactsListLimit + " items");
    }
    this.contactsStatus.forEach((status)=>{
      this.contactsListsLimit[status.idContactsContactStatus] = this.contactsListLimit;
    });
  },
  mounted() {
    this.checkListLimitAfterResize();
  },
  destroyed() {
    // clearInterval(this.updateInterval);
    // this.$anm22.eventBus.$off("contact-selected");
    // this.$anm22.eventBus.$off("contacts-filter");
  },
};
</script>

<style lang="scss" scoped>
  .legend {
    padding: 10px; 
    flex-wrap: nowrap; 
    display: flex;
    white-space: nowrap;
    overflow-x:auto;
  }
  .status-list-header {
    text-align: center;

    .name {
      display: inline-block;
      vertical-align: middle;
      padding: 12px 6px;
      font-size: 18px;
    }
    .change-view,
    .sort-modal,
    .change-work {
      opacity:0.6;
      display: inline-block;
      vertical-align: middle;
      height: 20px;
      cursor:pointer;
      margin-left: 10px;
    }
    .work-img {
      display: inline-block;
      vertical-align: middle;
      border-radius:10px;
      height: 20px;
      width:20px;
    }
  }
  @media (min-width: 992px) {
    .status-list-header {
      .change-view,
      .sort-modal {
        display: none;
      }
    }
  }
  .status-list-container {
    white-space: nowrap;
    max-width: calc(100vw - 60px);
    box-sizing: border-box;
    overflow-x: auto;
  }
  @media only screen and (max-width: 767px) {
    .status-list-container {
      max-width: 100vw;
    }
  }
  .cont {
    position: relative;
    font-weight: normal;
    min-height: 15px;
    padding:6px;
    border-radius: 10px;
    cursor:pointer;
  
  }
  .cont:hover {
    background-color: #eee;
  }
  .cont-tick {
    margin-left:auto;
  }
  .status-box {
    display: inline-block;
    vertical-align: top;
    width:300px;
    background-color: #eee;
    border-radius: 14px;
    margin: 10px;
    box-sizing: border-box;
    padding: 10px;
    overflow-y: auto;
    max-height: calc(100vh - 180px);
    white-space: normal;

    .status-name {
      text-align: center;
      text-transform: uppercase;
      font-size: 14px;
      color:#444;
      font-weight: bold;

      .counter {
        font-weight: normal;
        color:#222;
        font-size: 12px;
      }
      .name-label {
        padding:1px 1px 1px 5px;
        vertical-align: middle;
      }
    }

    .item {
      flex-wrap: nowrap;
      align-items: center;
      min-height: 60px;
      padding: 10px;
      position: relative;
      background-color: #fff;
      border-radius: 7px;
      margin-top: 6px;
      box-shadow: 0 3px 15px rgba(0, 0, 0, 0.1);

      &:first-child {
        margin-top: 0px;
      }

      &.selectable {
        cursor: pointer;
      }
      &.selectable:hover {
        background: #f5f5f5;
      }
      &.selectable.selected {
        background: #f5f5f5;
      }
      
      .image {
        width: 40px;
        height: 40px;
        border: 1px solid #eee;
        border-radius: 20px;
        margin-right: 5px;
        //box-sizing:content-box;
      }
      &.to-read .image {
        // background:
        // linear-gradient(#fff,#fff) padding-box,
        // linear-gradient(to left,#2145f3f5, #60aeeb) border-box;
        // color: #313149;
        border: 2px solid #eee;
        border-color: grey;
        border-image-width: 2px;
        //border: 2px solid transparent;
        // border-radius:20px;
        //display:inline-block;
        //margin: 75px 0;
      }
      &.blue .image {
        border: 2px solid #eee;
        border-color: #007fff!important ;
        border-image-width: 2px;
      }
      &.yellow .image {
        border: 2px solid #eee;
        border-color: #F6BE00!important;
        border-image-width: 2px;
      }
      &.red .image {
        border: 2px solid #eee;
        border-color: #f00!important ;
        border-image-width: 2px;
      }
      .name {
        margin-bottom: 4px;
      }
      &.to-read .name {
        font-weight: bold;
      }
      .label {
        border-radius: 4px;
        background-color: #eee;
        font-size: 12px;
        color: #666;
        display: inline-block;
        padding: 2px 4px;
      }
      .contact-last-feed,
      .contact-value,
      .contact-pause {
        border-radius: 4px;
        font-size: 12px;
        color: #000;
        display: block;
        padding: 2px 4px 2px 13px;
        background-image: url(../../../../utilities/img/icons/chat-bubble.svg);
        background-size: 10px 10px;
        background-position: 0px center;
        background-repeat: no-repeat;
        opacity: 0.6;
      }
      .referent {
        opacity: 0.6;
        font-size: 12px;
        margin-left:2px;
      }
      .contact-value {
        background-image: url(../../../../../world/libs/anm22_icons/img/icons/cash.svg);
        background-size: 13px 13px;
        margin-right:5px;
      }
      .contact-last-feed {
        background-image: url(../../../../utilities/img/icons/chat-bubble.svg);
        margin-right: 5px;
      }
      .contact-pause {
        padding: 2px 6px 2px 19px;
        background-position: 4px center;
        background-image: url(../../../../utilities/img/icons/pause.svg);
        background-color: #ddd;
      }
    }
  }
  .status-box.filters {
    max-height: calc(100vh - 210px);
  }
  .filter-button {
    flex-wrap: nowrap;
    align-items: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    background-color: #ddd;
    border-radius: 5px;
    padding: 6px;
    margin: 0 5px;
  }
.bar-div {
  width: 8px;
  background-color: #555;
  position: relative;
}
.bar-select {
  width: 8px;
  height: 50px;
  border: 2px solid #555;
  border-radius: 5px;
  top: 50%;
  left: 0;
  right: 0;
  position: absolute;
  cursor: pointer;
  background-color: #aaa;
    &:hover {
      background-color: #bbb;
    }
}

.name span {
  margin-left: 2%;
}
</style>

